<template>
    <div :style="{maxWidth: maxWidth}" class='textfield'>
        <input ref="input" type='text' :placeholder="placeholder" @keyup.enter="enter" @input="input">
        <span @click="click"><fa-icon icon="arrow-circle-right" /></span>
    </div>
</template>

<script>
export default {
    name: 'textfield',
    props: {
        maxWidth: {type: String, default: "100%"},
        placeholder: {type: String},
        vModel: {required: false}
    },

    methods: {
        click() {
            this.$emit('enter', this.$refs.input);
        },

        enter(el){
            this.$emit('enter', el.target)
        },

        input(el){
            this.$emit('input', el.target);
        },

        clear(){
            this.$refs.input.value = "";
        }
    }
}
</script>

<style lang="scss" scoped>
    .textfield {
        position: relative;
        input {width: 100%;}
        svg {position: absolute; right: 15px; font-size: 26px; top: 50%; margin-top: -13px; }
    }   

</style>